import { ResolveFn } from '@angular/router';
import { StatusService } from './status.service';
import { inject } from '@angular/core';

export const allStatusesResolver: ResolveFn<void> = async () => {
  await inject(StatusService).fetchAllStatusesLookup();
}
